<template>
  <div>
    <b-modal ref="editActivityNoteModal" size="lg" title="Edit Activity/Note">
      <template v-slot:modal-header="{ close }">
        <div class="row" style="width: 100%;">
          <div class="col-12">
            <div>
              <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                edit
              </i>
            </div>
            <div class="wd-modal-subheader">
              <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Edit Activity/Note</h3>
            </div>
            <button type="button" class="close" @click="close()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="wd-modal-body">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :width="50"
                 :height="50"
                 :is-full-page="false">
        </loading>

        <div class="row">
          <div class="col-md-6">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="activity">Activity*</label>
              <b-form-select v-model="formData.activity" :options="activityOptions" class="form-control" :disabled="isSystemActivity">
                <option :value="null">Select Activity</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="type">Type*</label>
              <div class="wd-v-multi-select">
                <multiselect id="type" select-label="Click to select" deselect-label="Click to remove"
                  v-model="formData.type" :options="['Accounting', 'Estimating', 'Production']"
                  :multiple="true" :close-on-select="false" :clear-on-select="false"
                  placeholder="Please Select" :disabled="isSystemActivity">
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-md-6" v-if="!isSystemActivity">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="contact">Contact</label>
              <b-form-select v-model="formData.contact" :options="contactOptions" class="form-control">
                <option :value="null">Select Contact</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6" v-if="!isSystemActivity">
            <div class="wd-checkbox" style="margin: 17px 0;">
              <label>
                <input type="checkbox" v-model="formData.followUp" />
                <span class="checkbox-decorator">
                  <span class="check"></span>
                </span>
                Follow Up
              </label>
            </div>
          </div>

          <div class="col-md-6" v-if="formData.followUp && !isSystemActivity">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="user">Assigned To*</label>
              <b-form-select v-model="formData.assignedTo" :options="userOptions" class="form-control">
                <option :value="null">Select User</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6" v-if="formData.followUp && !isSystemActivity">
            <div class="wd-webix-input">
              <label for="deadline" class="wd-v-select-label">Deadline*</label>
              <b-form-input type="date" v-model="formData.deadline" class="form-control"></b-form-input>
            </div>
          </div>

          <div class="col-md-12" v-if="!isSystemActivity">
            <div class="wd-textarea">
              <label for="note">Details*</label>
              <textarea v-model="formData.note" rows="5" maxlength="10000" class="form-control"></textarea>
              <div class="text-right text-muted" v-if="formData.note">{{ formData.note.length }}/10000</div>
              <div class="text-right text-muted" v-else>0/10000</div>
            </div>
          </div>


        </div>
      </div>

      <template v-slot:modal-footer>
        <button type="button" class="btn btn-danger" @click="deleteActivity" :disabled="isSaving || isSystemActivity">
          <i v-if="isSaving" class="fa fa-spinner fa-spin mr-2"></i>Delete
        </button>
        <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveActivity" :disabled="isSaving || isSystemActivity">
          <i v-if="isSaving" class="fa fa-spinner fa-spin mr-2"></i>Save
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CommonConstants from '@/constants/constants.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'

export default {
  name: 'EditActivityNoteModal',
  components: {
    Loading,
    Multiselect
  },
  props: {
    activities: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  emits: ['activityUpdated'],
  data() {
    return {
      constants: CommonConstants,
      isLoading: false,
      isSaving: false,
      currentActivityId: null,
      isSystemActivity: false,
      formData: {
        activity: null,
        type: [],
        contact: null,
        followUp: false,
        assignedTo: null,
        deadline: null,
        note: ''
      }
    }
  },
  computed: {
    header() {
      return {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
    },
    activityOptions() {
      if (!this.activities || this.activities.length === 0) {
        return []
      }
      return this.activities.map(a => ({
        value: a.id,
        text: a.value
      }))
    },
    typeOptions() {
      return [
        { value: 'Accounting', text: 'Accounting' },
        { value: 'Estimating', text: 'Estimating' },
        { value: 'Production', text: 'Production' }
      ]
    },
    contactOptions() {
      if (!this.contacts || this.contacts.length === 0) {
        return []
      }
      return this.contacts.map(c => ({
        value: c.id,
        text: c.first_name && c.last_name ? `${c.first_name} ${c.last_name}` : (c.first_name || c.last_name || 'Unknown')
      }))
    },
    userOptions() {
      if (!this.users || this.users.length === 0) {
        return []
      }
      return this.users.map(u => ({
        value: u.id,
        text: u.value
      }))
    }
  },
  methods: {
    show(activityData) {
      this.currentActivityId = activityData.id
      this.isSystemActivity = activityData.type === 'system' || activityData.type === 'System'

      if (this.isSystemActivity) {
        this.$vueConfirm.confirm(
          {
            message: 'This is a system-generated activity and cannot be edited.',
            button: {
              no: 'Close',
              yes: 'Close'
            }
          },
          function() {}
        )
        return
      }

      let deadline = activityData.deadline || null
      if (deadline && typeof deadline === 'string') {
        deadline = deadline.split(' ')[0]
      }

      let typeArray = []
      if (activityData.type) {
        if (typeof activityData.type === 'string') {
          typeArray = activityData.type.split(',').map(t => t.trim()).filter(t => t)
        } else if (Array.isArray(activityData.type)) {
          typeArray = activityData.type
        }
      }

      this.formData = {
        activity: activityData.activity_id || activityData.activity,
        type: typeArray,
        contact: activityData.job_contacts_id || activityData.contact_id || null,
        followUp: activityData.follow_up === '1' || activityData.follow_up === 1,
        assignedTo: activityData.assigned || activityData.assigned_id || null,
        deadline: deadline,
        note: activityData.note || ''
      }
      
      this.$nextTick(() => {
        this.$refs.editActivityNoteModal.show()
      })
    },
    closeModal() {
      this.$refs.editActivityNoteModal.hide()
    },
    async saveActivity() {
      if (!this.validateForm()) {
        return
      }

      this.isSaving = true
      try {
        const data = {
          activity: this.formData.activity,
          type: this.formData.type && this.formData.type.length > 0 ? this.formData.type : [],
          contact: this.formData.contact || null,
          note: this.formData.note,
          assigned: this.formData.followUp ? this.formData.assignedTo : null,
          deadline: this.formData.followUp ? this.formData.deadline : null,
          'follow-up': this.formData.followUp ? '1' : '0'
        }

        const response = await axios.post(
          this.constants.api_url + 'job/note/update/' + this.currentActivityId,
          data,
          this.header
        )

        if (response.data.flag) {
          this.$emit('activityUpdated')
          this.closeModal()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error updating activity: ' + (response.data.message || 'Unknown error'),
            iconColor: '#dc3545',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
        }
      } catch (error) {
        console.error('Error updating activity:', error)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error updating activity: ' + (error.response?.data?.message || error.message),
          iconColor: '#dc3545',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
      } finally {
        this.isSaving = false
      }
    },
    deleteActivity() {
      Swal.fire({
        icon: 'warning',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this activity?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        iconColor: '#ff9800',
        didOpen: (modal) => {
          const icon = modal.querySelector('.swal2-icon')
          if (icon) {
            icon.style.margin = '20px auto 0 auto'
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.performDelete()
        }
      })
    },
    async performDelete() {
      this.isSaving = true
      try {
        const data = {
          selected_notes: [this.currentActivityId]
        }

        const response = await axios.post(
          this.constants.api_url + 'job/note/remove',
          data,
          this.header
        )

        if (response.data.flag) {
          this.$emit('activityUpdated')
          this.closeModal()
          Vue.$toast('Activity deleted successfully', {
            position: 'top',
            type: 'success',
            duration: 3000
          })
        } else {
          Vue.$toast('Error deleting activity: ' + (response.data.message || 'Unknown error'), {
            position: 'top',
            type: 'error',
            duration: 3000
          })
        }
      } catch (error) {
        console.error('Error deleting activity:', error)
        Vue.$toast('Error deleting activity: ' + (error.response?.data?.message || error.message), {
          position: 'top',
          type: 'error',
          duration: 3000
        })
      } finally {
        this.isSaving = false
      }
    },
    validateForm() {
      if (!this.formData.activity) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Activity is required',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (!this.formData.type || this.formData.type.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Type is required. Please select at least one type',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (!this.formData.note || !this.formData.note.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Details is required',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (this.formData.followUp) {
        if (!this.formData.assignedTo) {
          Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Assigned To is required when Follow Up is checked',
            iconColor: '#ff9800',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
          return false
        }
        if (!this.formData.deadline) {
          Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Deadline is required when Follow Up is checked',
            iconColor: '#ff9800',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.wd-modal-body {
  padding: 20px;
}

.wd-modal-subheader {
  display: inline-block;
  vertical-align: top;
  margin-top: 8px;
}

.wd-v-select-label {
  font-weight: 500;
  margin-bottom: 5px;
}

.wd-v-multi-select {
  position: relative;
  z-index: 10;
}

.wd-v-multi-select .multiselect {
  z-index: 10;
}

.wd-v-multi-select .multiselect__content-wrapper {
  z-index: 1000;
}

.wd-checkbox {
  margin: 17px 0;
}

.wd-checkbox label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}

.wd-textarea {
  margin-bottom: 15px;
}

.wd-textarea label {
  font-weight: 500;
  margin-bottom: 5px;
  display: block;
}

.text-right {
  text-align: right;
}

.text-muted {
  color: #6c757d;
  font-size: 12px;
}

.alert {
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 0;
}

.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}
</style>

